/* 
 * Export component file to be used on project
*/

import RescheduleContainer from './RescheduleContainer.js';
export default RescheduleContainer;
